// import React, {
//   useCallback,
//   useEffect,
//   useState,
//   useContext,
//   useRef,
// } from "react";
// import { useParams } from "react-router-dom";
// import { useMsal } from "@azure/msal-react";
// import axios from "axios";
// import { protectedResources } from "./msalConfig";

export const GetToken = async (props) => {
  const { instance, request } = props;
  try {
    // Use MSAL to authenticate and acquire token silently
    const authResponse = await instance.acquireTokenSilent(request);

    return authResponse.accessToken;
  } catch (error) {
    console.error("Authentication error:", error);
    throw error;
  }
};
